import { useRouter } from 'next/router';
import React from 'react';
import { DEFENSE_COMPAMIES } from '../../consts/content-types';
import {
  ChildSubCategory,
  ParentSubCategory,
} from '../../shared-styled/blocks/SubCategories';
import { CategoryNav } from '../../shared-styled/layout/CategoryContainer';
import { NoUnderlineAnchor } from '../../shared-styled/typography/Anchors';
import CategoryName from '../CategoryName/CategoryName';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import UniversalLink from '../UniversalLink/UniversalLink';

const CategoryNavigation = ({ isMulticategory, parentItm, className }) => {
  const router = useRouter();
  const { navItems } = useGlobalContext();

  if (router.asPath === '/_preview') {
    return (
      <CategoryNav>
        <CategoryName isActive={false} />
      </CategoryNav>
    );
  }

  if (!navItems || !(navItems.length > 0)) {
    return null;
  }

  const parentDisplayedTitles = ['News', 'Reports', DEFENSE_COMPAMIES];
  const childDisplayedTitles = [
    'Militant Organizations',
    'Militant Organizations (Historical)',
    'Armed Forces',
  ];
  const isParentDisplayed = !parentDisplayedTitles.includes(navItems[0].title);
  const isChildDisplayed = !childDisplayedTitles.includes(navItems[0].title);

  return (
    <CategoryNav className={className}>
      <UniversalLink href={navItems[0].url} passHref>
        <NoUnderlineAnchor>
          <CategoryName
            isActive={isParentDisplayed ? navItems.length === 1 : false}
          >
            {navItems[0].title}
          </CategoryName>
        </NoUnderlineAnchor>
      </UniversalLink>
      {navItems[1] &&
        isParentDisplayed &&
        (!isChildDisplayed && isMulticategory ? (
          parentItm.map((subCategory, i) => (
            <UniversalLink
              key={subCategory.title}
              href={subCategory.url.split('/').slice(0, -1).join('/')}
              passHref
            >
              <NoUnderlineAnchor>
                <ChildSubCategory $isActive={navItems.length === 3}>
                  {(subCategory.titleCategory || subCategory.title) +
                    (i === parentItm.length - 1 ? '' : ',')}
                </ChildSubCategory>
              </NoUnderlineAnchor>
            </UniversalLink>
          ))
        ) : (
          <UniversalLink href={navItems[1].url} passHref>
            <NoUnderlineAnchor>
              <ParentSubCategory $isActive={navItems.length === 2}>
                {navItems[1].title}
              </ParentSubCategory>
            </NoUnderlineAnchor>
          </UniversalLink>
        ))}
      {navItems[2] &&
        isChildDisplayed &&
        (isMulticategory ? (
          parentItm.map((subCategory, i) => (
            <UniversalLink
              key={subCategory.title}
              href={subCategory.url.split('/').slice(0, -1).join('/')}
              passHref
            >
              <NoUnderlineAnchor>
                <ChildSubCategory $isActive={navItems.length === 3}>
                  {(subCategory.titleCategory || subCategory.title) +
                    (i === parentItm.length - 1 ? '' : ',')}
                </ChildSubCategory>
              </NoUnderlineAnchor>
            </UniversalLink>
          ))
        ) : (
          <UniversalLink
            key={navItems[2].title}
            href={navItems[2].url}
            passHref
          >
            <NoUnderlineAnchor>
              <ChildSubCategory $isActive={navItems.length === 3}>
                {navItems[2].title}
              </ChildSubCategory>
            </NoUnderlineAnchor>
          </UniversalLink>
        ))}
    </CategoryNav>
  );
};

CategoryNavigation.defaultProps = {
  isMulticategory: false,
};

export default CategoryNavigation;
